import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  AVG_VIEWS,
  INFLUENCER_CATEGORY,
  INFLUENCER_TYPE,
} from "../../utils/constants";
import { addSocialDataValidation } from "../../utils/validation";
import { toast } from "react-toastify";

const SocialDetails = ({ nextStep, prevStep, handleChange, formData }) => {
  const [profilePicUrl, setProfilePicUrl] = useState(null);
  const [selectCategory, setSelectCategory] = useState(
    formData.category || null
  );
  const [selectType, setSelectType] = useState(formData.type || null);
  const [selectAvgViews, setSelectAvgViews] = useState(
    formData.avgViews || null
  );
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const requiredFields = [
    "instagramProfileLink",
    "instagramUserName",
    "numberOfFollowers",
    "youtubeChannelLink",
    "youtubeChannelName",
    "category",
    "type",
    "avgViews",
  ];

  const notifyError = (error) => toast.error(error);

  const validationError = addSocialDataValidation(
    formData.instagramProfileLink,
    formData.youtubeChannelLink
  );

  const validateForm = () => {
    return requiredFields.every((field) => {
      const value = formData[field];
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      return value !== null && value !== undefined;
    });
  };

  useEffect(() => {
    setIsButtonDisabled(!validateForm());
  }, [formData]);

  const handleNextClick = () => {
    if (!validationError) {
      nextStep();
    } else {
      notifyError(validationError);
    }
  };

  const categoryChangeHandler = (selectedValue) => {
    setSelectCategory(selectedValue);
    handleChange({
      target: { name: "category", value: selectedValue },
    });
  };
  const typeChangeHandler = (selectedValue) => {
    setSelectType(selectedValue);
    handleChange({
      target: { name: "type", value: selectedValue },
    });
  };
  const viewsChangeHandler = (selectedValue) => {
    setSelectAvgViews(selectedValue);
    handleChange({
      target: { name: "avgViews", value: selectedValue },
    });
  };

  const handleProfilePicChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      setProfilePicUrl(URL.createObjectURL(file));

      handleChange({
        target: { name: "profilePic", value: file },
      });
    }
  };

  const triggerFileInput = (e) => {
    e.preventDefault();
    document.getElementById("hidden-file-input").click();
  };

  return (
    <form>
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Instagram Profile Link
            </label>
            <input
              type="text"
              className="form-control"
              name="instagramProfileLink"
              value={formData.instagramProfileLink || ""}
              onChange={handleChange}
              id="exampleFormControlInput1"
              placeholder="Instagram Profile Link*"
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Instagram Username
            </label>
            <input
              type="text"
              className="form-control"
              name="instagramUserName"
              value={formData.instagramUserName || ""}
              onChange={handleChange}
              id="exampleFormControlInput1"
              placeholder="Instagram Username*"
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              No. of Followers
            </label>
            <input
              type="text"
              className="form-control"
              name="numberOfFollowers"
              value={formData.numberOfFollowers || ""}
              onChange={handleChange}
              id="exampleFormControlInput1"
              placeholder="No. of Followers*"
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Youtube Channel Link
            </label>
            <input
              type="text"
              className="form-control"
              name="youtubeChannelLink"
              value={formData.youtubeChannelLink || ""}
              onChange={handleChange}
              id="exampleFormControlInput1"
              placeholder="Youtube Channel Link*"
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Youtube Channel Name
            </label>
            <input
              type="text"
              className="form-control"
              name="youtubeChannelName"
              value={formData.youtubeChannelName || ""}
              onChange={handleChange}
              id="exampleFormControlInput1"
              placeholder="Youtube Channel Name*"
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Primary Category
            </label>
            <Select
              value={selectCategory}
              onChange={categoryChangeHandler}
              name="category"
              options={INFLUENCER_CATEGORY}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "#e3f3f6",
                  primary: "#e3f3f6",
                },
              })}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  minHeight: "35px",
                  height: "35px",
                  borderColor: "#dee2e6",
                  "&:hover": {
                    borderColor: "#dee2e6",
                  },
                }),
                valueContainer: (baseStyles) => ({
                  ...baseStyles,
                  padding: "2px 8px",
                }),
                input: (baseStyles) => ({
                  ...baseStyles,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (baseStyles) => ({
                  ...baseStyles,
                  height: "35px",
                }),
                dropdownIndicator: (baseStyles) => ({
                  ...baseStyles,
                  padding: "4px",
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  color: "black",
                }),
                singleValue: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                }),
              }}
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Influencer Type
            </label>
            <Select
              value={selectType}
              onChange={typeChangeHandler}
              name="type"
              options={INFLUENCER_TYPE}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "#e3f3f6",
                  primary: "#e3f3f6",
                },
              })}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  minHeight: "35px",
                  height: "35px",
                  borderColor: "#dee2e6",
                  "&:hover": {
                    borderColor: "#dee2e6",
                  },
                }),
                valueContainer: (baseStyles) => ({
                  ...baseStyles,
                  padding: "2px 8px",
                }),
                input: (baseStyles) => ({
                  ...baseStyles,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (baseStyles) => ({
                  ...baseStyles,
                  height: "35px",
                }),
                dropdownIndicator: (baseStyles) => ({
                  ...baseStyles,
                  padding: "4px",
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  color: "black",
                }),
                singleValue: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                }),
              }}
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Average Views
            </label>
            <Select
              onChange={viewsChangeHandler}
              name="avgViews"
              value={selectAvgViews}
              options={AVG_VIEWS}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "#e3f3f6",
                  primary: "#e3f3f6",
                },
              })}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  minHeight: "35px",
                  height: "35px",
                  borderColor: "#dee2e6",
                  "&:hover": {
                    borderColor: "#dee2e6",
                  },
                }),
                valueContainer: (baseStyles) => ({
                  ...baseStyles,
                  padding: "2px 8px",
                }),
                input: (baseStyles) => ({
                  ...baseStyles,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (baseStyles) => ({
                  ...baseStyles,
                  height: "35px",
                }),
                dropdownIndicator: (baseStyles) => ({
                  ...baseStyles,
                  padding: "4px",
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  color: "black",
                }),
                singleValue: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                }),
              }}
            />
          </div>
        </div>
        <div className="col-md-4 mt-2">
          <label htmlFor="exampleFormControlInput1" className="form-label">
            Upload Profile Pic
          </label>
          <button class="button-4" onClick={triggerFileInput}>
            Select Image
          </button>
        </div>
        {profilePicUrl && (
          <div className="col-md-6 mt-3">
            <img
              src={profilePicUrl}
              alt="profile pic"
              className="uploaded_profile_pic"
            />
          </div>
        )}
        <input
          type="file"
          className="form-control"
          name="profilePic"
          id="hidden-file-input"
          onChange={handleProfilePicChange}
          style={{ display: "none" }}
        />
      </div>
      <button className="prevBtn mt-5 me-2" onClick={prevStep}>
        Previous
      </button>
      <button
        type="button"
        className="nextBtn mt-5"
        onClick={handleNextClick}
        disabled={isButtonDisabled}
      >
        Next
      </button>
    </form>
  );
};

export default SocialDetails;
